import { render, staticRenderFns } from "./BookingEditView.vue?vue&type=template&id=5b1a10ab"
import script from "./BookingEditView.js?vue&type=script&lang=js&external"
export * from "./BookingEditView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports